import React from 'react';

export default function MockExamProcessing({ results, questionCount = 6 }) {
  const completed = results.filter(
    (r) => r.markingStatus === 'completed' || r.markingStatus === 'error',
  ).length;

  return (
    <div className="flex flex-col items-center justify-center h-full px-6 py-12">
      <div className="w-full max-w-md">
        {/* Banner */}
        <div className="flex items-center gap-3 bg-[#161b22] border border-[#30363d] rounded-xl px-5 py-4 mb-6">
          <div className="flex gap-1">
            <span className="w-2 h-2 rounded-full bg-[#58a6ff] animate-pulse" style={{ animationDelay: '0ms' }} />
            <span className="w-2 h-2 rounded-full bg-[#58a6ff] animate-pulse" style={{ animationDelay: '200ms' }} />
            <span className="w-2 h-2 rounded-full bg-[#58a6ff] animate-pulse" style={{ animationDelay: '400ms' }} />
          </div>
          <div>
            <p className="text-[#e6edf3] text-sm font-semibold">AI is marking your exam</p>
            <p className="text-[#8b949e] text-xs mt-0.5">
              {completed} of {questionCount} questions marked
            </p>
          </div>
        </div>

        {/* Skeleton cards */}
        <div className="space-y-3">
          {Array.from({ length: questionCount }).map((_, i) => {
            const result = results[i];
            const isDone =
              result?.markingStatus === 'completed' || result?.markingStatus === 'error';

            return (
              <div
                key={i}
                className={`rounded-xl border px-4 py-3 transition-colors ${
                  isDone
                    ? 'border-[#3fb950]/30 bg-[#3fb950]/5'
                    : 'border-[#30363d] bg-[#161b22]'
                }`}
              >
                <div className="flex items-center gap-3">
                  {isDone ? (
                    <span className="text-[#3fb950] text-sm">✓</span>
                  ) : (
                    <span
                      className="w-3.5 h-3.5 rounded-full border-2 border-[#8b949e] border-t-[#58a6ff] animate-spin flex-shrink-0"
                      style={{ animationDuration: '800ms' }}
                    />
                  )}
                  <div className="flex-1 min-w-0">
                    <div
                      className={`h-2.5 rounded ${
                        isDone ? 'bg-[#3fb950]/20' : 'bg-[#30363d] animate-pulse'
                      }`}
                      style={{ width: `${55 + (i * 17) % 35}%` }}
                    />
                  </div>
                  <span className="text-[10px] font-mono text-[#484f58]">
                    Q{i + 1}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
